var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"店铺商品","name":"relmall"}},[_c('relMallList',{attrs:{"is-load":_vm.relmall_status,"distributor-id":_vm.distributor_id}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }